var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4435 6.16339L16.5758 9.63955L20 5.52399L19.2268 4.88575L16.9771 7.59075C16.5201 3.34673 12.9813 0.0994883 8.7073 0.00223783C4.43328 -0.0950127 0.750005 2.9879 0.0998253 7.20672C-0.550355 11.4255 2.03427 15.4714 6.13986 16.6616C10.2454 17.8517 14.5983 15.8169 16.312 11.9064L15.3924 11.5039C13.8771 14.9751 10.011 16.7775 6.37265 15.709C2.73429 14.6404 0.461381 11.035 1.0699 7.29748C1.67842 3.55994 4.9781 0.858994 8.76811 0.996114C12.5581 1.13323 15.6533 4.06554 15.9893 7.83725L13.0909 5.39859L12.4435 6.16339Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.4b7edb488b531dcca2054f040c58d9e9f0e93498f8db2126a0390a64bf63ecf6.svg";
export { ForwardRef as ReactComponent };